var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"business-needs"},[_c('div',{staticClass:"business-needs__container"},[(_vm.title)?_c('div',{staticClass:"business-needs__title"},[_c('hot-title',{attrs:{"tag":"h2"}},[_vm._v(_vm._s(_vm.title))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"business-needs__carousel"},[_c('hot-carousel',{attrs:{"component":{
          is: _vm.cardFeature,
          name: 'cardFeature',
          items: _vm.items,
        },"swiper-options":_vm.swiperOptions}})],1),_vm._v(" "),(_vm.body)?_c('div',{staticClass:"business-needs__body",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }